import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth/auth.service';

@Component({
  selector: 'app-business-details-bar',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './business-details-bar.component.html',
  styleUrls: ['./business-details-bar.component.css'],
})
export class BusinessDetailsBarComponent implements OnInit {
  bizName = '';
  bizAccountNumber = '';
  userName = '';
  lastLoginDate: string | Date = '';
  today = new Date();

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    this.bizAccountNumber = this.authService.getCompanyId() || '';
    const d = this.authService.getCompanyDetails();
    if (d) {
      this.bizName = d.companyName || '';
      this.userName = `${d.firstName || ''} ${d.lastName || ''}`.trim();
      this.lastLoginDate = d.lastLoginDate || '';
    }
  }
}
